import script from "./MapExample.vue?vue&type=script&setup=true&lang=js"
export * from "./MapExample.vue?vue&type=script&setup=true&lang=js"

import "./MapExample.vue?vue&type=style&index=0&id=0fddc2ca&scoped=true&lang=css"

import exportComponent from "C:\\Master\\vue-notus-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fddc2ca"]])

export default __exports__